import { ChangeDetectionStrategy, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { GasRange } from '../gas-range.namespace';

//import { GasDebounce } from 'projects/ui-kit/src';
// todo: разобраться почему projects/ui-kit/src не работает
import { GasDebounce } from '../../helpers/function-decorators.helper';
import { GasForm } from '../../../forms/gas-form.namespace';

@Component({
  selector: 'gas-number-range',
  templateUrl: './gas-number-range.component.html',
  styleUrls: ['./gas-number-range.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GasNumberRangeComponent),
    multi: true,
  }],
})
export class GasNumberRangeComponent implements ControlValueAccessor, OnInit {

  @Input()
  public label = '';

  @Input()
  public set min(min: number) {
    this.smallestValue = GasRange.calcSmallestNumericValue(min);
  };

  public get min(): number {
    return this.smallestValue;
  }

  @Input()
  public set max(max: number) {
    this.largestValue = GasRange.calcLargestNumericValue(max);
  };

  public get max(): number {
    return this.largestValue;
  }

  public minValue: number;

  public maxValue: number;

  public error$ = new BehaviorSubject<string>('');

  private smallestValue: number;

  private largestValue: number;

  @GasDebounce()
  public updateMinValue(value: GasForm.GasFilterFormBaseValue): void {
    this.minValue = Number(value);
    this.error$.next(this.calculateErrorText());
    this.dispatchOnChange();
  }

  @GasDebounce()
  public updateMaxValue(value: GasForm.GasFilterFormBaseValue): void {
    this.maxValue = Number(value);
    this.error$.next(this.calculateErrorText());
    this.dispatchOnChange();
  }

  public ngOnInit(): void {
    if (this.smallestValue > this.largestValue) {
      console.error('Минимальное значение не может быть больше максимального');
    }
  }

  public writeValue(obj: any): void {
    if (obj && Array.isArray(obj)) {
      const [min, max]: number[] = obj;
      this.minValue = Number(min);
      this.maxValue = Number(max);
      this.error$.next(this.calculateErrorText());
    }
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    // todo: обработать дизейбл
  }

  protected onChange = ([min, max]: [number, number]) => {
  };
  protected onTouched = () => {
  };

  private dispatchOnChange(): void {
    this.onChange([this.minValue, this.maxValue]);
  }

  private calculateErrorText(): string {
    if (!this.minValue || !this.maxValue) {
      return '';
    }
    if (this.minValue < this.min) {
      return `Минимальное значение не может быть меньше ${this.min}`;
    }
    if (this.minValue > this.max) {
      return `Минимальное значение не может быть больше ${this.max}`;
    }
    if (this.maxValue > this.max) {
      return `Максимальное значение не может быть больше ${this.max}`;
    }
    if (this.maxValue < this.min) {
      return `Максимальное значение не может быть меньше ${this.min}`;
    }
    if (this.minValue > this.maxValue) {
      return 'Минимальное значение не может быть больше максимального';
    }

    return '';
  }

}
